import { Observable } from 'rxjs';
import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class NamingPageService {
    private currentPage: EventEmitter<string> = new EventEmitter<string>();

    constructor() {
        this.currentPage.next('');
    }

    public setCurrentPage(name: string) {
        this.currentPage.next(name);
    }

    public onPageNameChange() {
        return this.currentPage.asObservable();
    }
}
